import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      // We delay CSRF meta setting due to race condition in redis session storage
      // that may result in ActionController::InvalidAuthenticityToken errors.
      fetch("/accounts/csrf_meta.json", { credentials: "same-origin" })
        .then(response => response.json())
        .then(function(json) {
          $("<meta>")
            .attr("name", "csrf-param")
            .attr("content", json.param)
            .appendTo("head");

          $("<meta>")
            .attr("name", "csrf-token")
            .attr("content", json.token)
            .appendTo("head");
        });
    });
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/csrf_meta_controller.js